/* Auto Refill ships free: say so in the Kaching drawer's free-shipping line.
 *
 * DEC116 / TSK551 fix 1, 29 Sep 2026. Kaching's tiered promotions bar counts the cart total only,
 * so a cart of Auto Refill items under $79 read "Add $47.01 to unlock Free U.S. Shipping" (measured,
 * one Auto Refill balm, $31.99). Checkout already ships it free: every selling plan group (the Kay+
 * Aura+System ladder, Cleanser Refill, Partner Vendors) sits in the delivery profile "Subscriber Free
 * Standard", US Standard $0, no minimum (Admin API, 29 Sep 2026). One-time lines stay in the General
 * profile ($6.95 under $79), so the line is only rewritten when EVERY paid line is on a plan and the
 * market is the US. A mixed cart keeps Kaching's own message. Kaching's nodes are never removed; only
 * the text of the shipping line is replaced, and only while that line is about shipping.
 */
(function () {
  'use strict';

  var MESSAGE = 'Free U.S. shipping unlocked. Auto Refill ships free from your first order.';
  var SHIPPING_LINE = /unlock\s+free\s+u\.?s\.?\s+shipping/i;

  // Pure decision, exported for tests: true when the cart ships free because of Auto Refill alone.
  function autoRefillShipsFree(cart, country) {
    if (!cart || !Array.isArray(cart.items) || country !== 'US') return false;
    var paid = cart.items.filter(function (i) { return i && i.requires_shipping !== false && i.final_line_price > 0; });
    if (!paid.length) return false;
    return paid.every(function (i) { return Boolean(i.selling_plan_allocation); });
  }

  if (typeof window !== 'undefined') window.BohemiaAutoRefillShip = { autoRefillShipsFree: autoRefillShipsFree, MESSAGE: MESSAGE };
  if (typeof document === 'undefined') return;

  var country = (window.Shopify && window.Shopify.country) || '';
  var free = null;
  var pending = null;

  function paint() {
    var nodes = document.querySelectorAll('.kaching-cart__tiered-promotions-bar-text');
    for (var k = 0; k < nodes.length; k += 1) {
      var node = nodes[k];
      if (free && node.textContent !== MESSAGE && SHIPPING_LINE.test(node.textContent)) node.textContent = MESSAGE;
    }
  }

  function check() {
    if (pending) return pending;
    pending = fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) free = autoRefillShipsFree(cart, country); paint(); })
      .catch(function () {})
      .then(function () { pending = null; });
    return pending;
  }

  // Kaching re-renders the bar on every cart change, which drops our text: repaint
  // from the cached decision at once, and re-read the cart when the bar asks about shipping again.
  var timer = null;
  var observer = new MutationObserver(function () {
    if (!document.querySelector('.kaching-cart__tiered-promotions-bar-text')) return;
    paint();
    window.clearTimeout(timer);
    timer = window.setTimeout(check, 250);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  ['cart:change', 'kaching-cart:item-added', 'bohemia:cart-updated'].forEach(function (name) {
    document.addEventListener(name, function () { free = null; check(); });
  });
})();
